import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Star } from "lucide-react";
import Logo from "./Logo";
import { SITE } from "../data/site";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="relative overflow-hidden bg-bee text-cream"
        >
            <div className="wrap py-14 sm:py-16">
                <div className="grid gap-12 lg:grid-cols-[1.3fr_0.8fr_1.2fr]">
                    <div>
                        <Logo light testId="footer-official-logo" />
                        <p className="mt-5 max-w-xs leading-relaxed text-cream/70">
                            A playful, nurturing early learning academy for
                            little ones ages 6 weeks to 5 years. Play-based,
                            family-first, and full of happy buzz.
                        </p>
                        <div className="mt-5 flex items-center gap-1.5">
                            {Array.from({ length: 5 }).map((_, i) => (
                                <Star
                                    key={i}
                                    className="h-4 w-4 fill-honey-bright text-honey-bright"
                                />
                            ))}
                        </div>
                    </div>
                    <nav aria-label="Footer">
                        <p className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-honey-bright">
                            Explore
                        </p>
                        <ul className="mt-4 space-y-2.5 text-cream/80">
                            <li>
                                <Link
                                    to="/"
                                    data-testid="footer-link-home"
                                    className="transition-colors hover:text-honey-bright"
                                >
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/programs"
                                    data-testid="footer-link-programs"
                                    className="transition-colors hover:text-honey-bright"
                                >
                                    Programs
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/about"
                                    data-testid="footer-link-about"
                                    className="transition-colors hover:text-honey-bright"
                                >
                                    About Us
                                </Link>
                            </li>
                        </ul>
                    </nav>
                    <div>
                        <p className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-honey-bright">
                            Say Hello
                        </p>
                        <ul className="mt-4 space-y-3.5 text-cream/80">
                            <li
                                data-testid="footer-contact-address"
                                className="flex items-start gap-3"
                            >
                                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-honey-bright" />
                                {SITE.address}
                            </li>
                            <li
                                data-testid="footer-contact-phone"
                                className="flex items-start gap-3"
                            >
                                <Phone className="mt-0.5 h-5 w-5 shrink-0 text-honey-bright" />
                                <a
                                    href={SITE.phoneHref}
                                    className="transition-colors hover:text-honey-bright"
                                >
                                    {SITE.phone}
                                </a>
                            </li>
                            <li
                                data-testid="footer-contact-email"
                                className="flex items-start gap-3"
                            >
                                <Mail className="mt-0.5 h-5 w-5 shrink-0 text-honey-bright" />
                                <a
                                    href={`mailto:${SITE.email}`}
                                    className="transition-colors hover:text-honey-bright"
                                >
                                    {SITE.email}
                                </a>
                            </li>
                            <li
                                data-testid="footer-contact-hours"
                                className="flex items-start gap-3"
                            >
                                <Clock className="mt-0.5 h-5 w-5 shrink-0 text-honey-bright" />
                                {SITE.hoursLine}
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-cream/10 pt-6 text-sm text-cream/50 sm:flex-row">
                    <p>
                        © {new Date().getFullYear()}{" "}
                        {SITE.name}. All rights reserved.
                    </p>
                    <p>Crafted with honey & heart.</p>
                </div>
            </div>
        </footer>
    );
}
